// test2746
(2746 && 0);
